import { useMemo } from 'react';

import { useAbility } from '@casl/react';

import { getAllowedTaskResources } from '../../ability-from-session';

export { taskResources } from '../../ability-from-session';

/**
 * Custom hook to get the allowed task domains for the current user
 * @returns The allowed task domains for the current user
 */
export const useAllowedTaskDomains = () => {
  const ability = useAbility();
  return useMemo(() => getAllowedTaskResources(ability), [ability]);
};

/**
 * Custom hook to check if the current user can view priorities
 * @returns True if the user can view priorities, false otherwise
 */
export const useCanViewPriorities = () => {
  const allowedTaskDomains = useAllowedTaskDomains();
  return allowedTaskDomains.length > 1;
};
